import { render, staticRenderFns } from "./request-cancelation.vue?vue&type=template&id=1d85ae48&"
import script from "./request-cancelation.vue?vue&type=script&lang=js&"
export * from "./request-cancelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports